export default __webpack_public_path__ + "static/media/MF.345afbb3.svg";